<template>
  <div class="index">
    <router-link to="/">Index</router-link>
    404
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Page404"
};
</script>
